export default "/images/vendor/flag-icon-css/flags/4x3/tr.svg?2880fc8e0e28f4a11a8d5f7db508d4c6";